import { CONTACT } from "../lib/brand";
import { useReveal } from "../hooks/useReveal";

// Prominent contact CTA — appears right after the hero so bookings are one click away
export const ContactCTA = () => {
  const ref = useReveal();

  return (
    <section
      id="contact-cta"
      data-testid="contact-cta-section"
      className="bg-black text-white py-16 md:py-20 border-y border-black"
    >
      <div
        ref={ref}
        className="reveal max-w-[1480px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-8 md:gap-12 items-center"
      >
        {/* Headline */}
        <div className="col-span-12 md:col-span-7">
          <div className="label-eyebrow mb-4 opacity-70 flex items-center gap-3">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
            Bookings — open daily
          </div>
          <h2 className="font-display leading-[0.95] tracking-[-0.01em] text-[2.4rem] md:text-6xl">
            Ready to book? <br />
            <span className="italic">Let's talk.</span>
          </h2>
          <p className="font-body text-sm md:text-[15px] leading-[1.8] text-white/75 mt-5 max-w-lg">
            Reach us any day, 8AM–10PM. Quotes returned within the day.
          </p>
        </div>

        {/* Direct-contact column */}
        <div className="col-span-12 md:col-span-5 flex flex-col gap-5">
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="cta-email"
            className="group flex items-center justify-between gap-4 py-4 border-b border-white/25 transition-colors hover:border-white"
          >
            <span>
              <span className="label-eyebrow block opacity-60 mb-1">Email</span>
              <span className="font-display text-xl md:text-2xl">
                {CONTACT.email}
              </span>
            </span>
            <span className="font-display text-xl transition-transform group-hover:translate-x-1">
              →
            </span>
          </a>
          <a
            href={CONTACT.phoneHref}
            data-testid="cta-phone"
            className="group flex items-center justify-between gap-4 py-4 border-b border-white/25 transition-colors hover:border-white"
          >
            <span>
              <span className="label-eyebrow block opacity-60 mb-1">Phone</span>
              <span className="font-display text-xl md:text-2xl">
                {CONTACT.phone}
              </span>
            </span>
            <span className="font-display text-xl transition-transform group-hover:translate-x-1">
              →
            </span>
          </a>

          <a
            href="#contact"
            data-testid="cta-form"
            className="mt-2 inline-flex items-center justify-center gap-2 px-8 py-5 rounded-full bg-white text-black font-body text-xs uppercase tracking-[0.28em] transition-all hover:tracking-[0.34em] hover:bg-white/90"
          >
            Send us an inquiry
          </a>
        </div>
      </div>
    </section>
  );
};
